import { Injectable } from '@angular/core';
import { AngularFireMessaging } from '@angular/fire/messaging';
import { BehaviorSubject } from 'rxjs';
@Injectable({
  providedIn: 'root',
})
export class MessagingService {
  currentMessage = new BehaviorSubject(null);
  constructor(private angularFireMessaging: AngularFireMessaging) {
    this.angularFireMessaging.messaging.subscribe((msg) => {
      msg.onMessage = msg.onMessage.bind(msg);
      msg.onTokenRefresh = msg.onTokenRefresh.bind(msg);
    });
  }

  // requestPermission() {
  //   this.angularFireMessaging.requestToken.subscribe(
  //       (token) => {
  //         console.log(token);
  //       },
  //       (err) => {
  //         console.error('Unable to get permission to notify.', err);
  //       }
  //   );
  // }

  requestPermission() {
    return this.angularFireMessaging.requestToken;
  }

  receiveMessage() {
    this.angularFireMessaging.messages.subscribe((payload) => {
      // console.log('new message received. ', payload);
      this.currentMessage.next(payload);
    });
  }
}
